// Laufzeit-Status der Session-Persistenz (Audit M8) — was der Autosave
// gerade tut, sichtbar für die UI.
//
//   autosaveError  — letzter fehlgeschlagener Save (QuotaExceededError …),
//                    dauerhaft als Banner gezeigt, bis ein Save gelingt.
//   lastSavedAt    — Zeitstempel des letzten erfolgreichen Saves, damit der
//                    Banner sagen kann, wie alt der gesicherte Stand ist.
//   retry          — von useSessionPersistence registriert: sofort erneut
//                    speichern.
//
// Bewusst kein Teil des Session-Stores: der wird persistiert, dieser Status
// beschreibt die Persistenz selbst.

import { create } from 'zustand';

interface PersistenceStatus {
  autosaveError: string | null;
  lastSavedAt: number | null;
  retry: (() => void) | null;
  setAutosaveError(message: string | null): void;
  markSaved(at?: number): void;
  setRetry(fn: (() => void) | null): void;
}

export const usePersistenceStore = create<PersistenceStatus>((set) => ({
  autosaveError: null,
  lastSavedAt: null,
  retry: null,
  setAutosaveError: (autosaveError) => set({ autosaveError }),
  markSaved: (at = Date.now()) => set({ autosaveError: null, lastSavedAt: at }),
  setRetry: (retry) => set({ retry }),
}));
